<template>
  <div class="drawer-dialog">
    <el-drawer
      :visible.sync="isMobleShow"
      direction="btt"
      :size="size"
      :show-close="false"
      :wrapperClosable="false"

    >
      <div slot="title" class="h5-dialog_content">
        <div class="h5-close" @click="closeH5Dialog">
          <i :class="iconClassName"></i>
        </div>
        <div class="h5-title ellipsis">{{ title }}</div>
      </div>
      <div class="h5-content" v-if="showInput">
        <input type="text" readonly class="d-hide-input">
        <el-input
          :placeholder="$t('输入地址')"
          v-model="inputValue"
          input-on-composing
          :clearable="true"
          class="input-search_style_reset-h5"
          prefix-icon="el-input__icon icon-outline_search"
        >
        </el-input>
      </div>
      <div class="h5-search-list" v-r-loading="loading">
        <slot></slot>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { stopScroll, openScroll } from '@/utils/baseUtil';

import i18n from '@/i18n/locale';
export default {
  name: 'DrawerDialog',
  components: {},
  props: {
    size: {
      type: String,
      default: '92%',
    },
    title: {
      type: String,
      default: i18n.t('地址'),
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    h5Visible: {
      type: Boolean,
      default: false,
    },
    showInput: {
      type: Boolean,
      default: true,
    },
    inputVal: {
      type: String,
      default: '',
      required: false,
    },
    iconClassName: {
      type: String,
      default: 'icon-outline_close',
      required: false,
    },
  },
  data() {
    return {
      inputValue: '',
    };
  },
  watch: {
    inputValue(newV) {
      this.$emit('update:inputVal', newV);
    },
    isMobleShow(newV) {
      if (newV) {
        // stopScroll()
      }else {
        this.inputValue = '';
        // openScroll() // 打开弹窗的时候，关闭
      }
    },
  },
  model: {
    prop: 'h5Visible',
    event: 'showsChange',
  },
  computed: {
    isMobleShow: {
      get: function() {
        return this.h5Visible;
      },
      set: function(value) {
        this.$emit('showsChange', value);
      },
    },
  },
  methods: {
    closeH5Dialog() {
      // 关闭移动端
      this.isMobleShow = false;
      this.$emit('closeH5Dialog');
    },
  },
};
</script>

<style lang="scss" src="./index.scss"></style>
